<div
  id="upgrade-request"
  class="page-layout simple fullwidth inner-scroll flex-column"
>
  <!-- HEADER -->
  <div class="gt2-theme">
    <div
      class="header accent pl-24 pr-24 h-80 mat-elevation-z1 flex-row-start-center"
    >
      <div class="flex-row-start-center">
        <mat-icon class="header-page-icon">{{ upgradeIcon }}</mat-icon>
        <div class="page-title">
          {{ "UPGRADE_REQUEST.TITLE" | translate }}
        </div>
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <div class="content p-24" fusePerfectScrollbar>
    <!-- Confirmation -->
    <div *ngIf="sent" class="card sent mat-elevation-z1">
      <mat-icon class="sent-icon">check_circle</mat-icon>
      <div class="sent-title">
        {{ "UPGRADE_REQUEST.SENT_TITLE" | translate }}
      </div>
      <p class="sent-text">{{ "UPGRADE_REQUEST.SENT_TEXT" | translate }}</p>
      <div class="gt2-buttons-theme">
        <button mat-stroked-button (click)="reset()">
          {{ "UPGRADE_REQUEST.SEND_ANOTHER" | translate }}
        </button>
      </div>
    </div>

    <!-- Formulaire -->
    <form
      *ngIf="!sent"
      class="card mat-elevation-z1"
      [formGroup]="form"
      (ngSubmit)="send()"
    >
      <p class="intro">{{ "UPGRADE_REQUEST.INTRO" | translate }}</p>

      <div class="block-title">
        {{ "UPGRADE_REQUEST.INTERESTED_IN" | translate }}
      </div>
      <div class="interests">
        <mat-checkbox
          *ngFor="let interest of interests"
          [formControlName]="interest.key"
          class="interest"
        >
          {{ interest.label | translate }}
        </mat-checkbox>
      </div>

      <mat-form-field class="message-field" appearance="outline">
        <mat-label>{{ "UPGRADE_REQUEST.MESSAGE" | translate }} *</mat-label>
        <textarea
          matInput
          formControlName="message"
          rows="6"
          [maxlength]="messageMax"
          [placeholder]="'UPGRADE_REQUEST.MESSAGE_PLACEHOLDER' | translate"
        ></textarea>
        <mat-hint align="end"
          >{{ form.get("message")?.value?.length || 0 }} /
          {{ messageMax }}</mat-hint
        >
      </mat-form-field>

      <div class="gt2-buttons-theme flex-row-end-center">
        <button
          mat-raised-button
          color="accent"
          type="submit"
          [disabled]="form.invalid || sending"
        >
          {{ "UPGRADE_REQUEST.SEND" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
